// extracted by mini-css-extract-plugin
export default {"DefaultView":"DefaultView_DefaultView__7nb0Y","isMain":"DefaultView_isMain__nk27v","main":"DefaultView_main__qtwiP"};